import classes from "./Loader.module.scss";

const Loading = () => (
  <span className={classes.loader}></span>
);

export default Loading;
